/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { ImageLoader } from '../../ImageLoader';
import { ImageLoaderTypes } from '../../ImageLoader/ImageLoaderTypes';
import { PosterImageProps } from './PosterImageProps';

import './PosterImage.scss';

const PosterImage: FunctionComponent<PosterImageProps> = ({ imageUrl, isAdult }) => {
    return (
        <div className={isAdult ? 'hidden' : ''} data-testid="guide-poster-image">
            <ImageLoader src={imageUrl} imageType={ImageLoaderTypes.POSTER_IMAGE} />
        </div>
    );
};

PosterImage.propTypes = {
    imageUrl: PropTypes.string,
    isAdult: PropTypes.bool,
};
export default PosterImage;
